import  BrandListQuery from '../../query/BrandList.query';
import  { updateBrandsList, updateBrandsTypeOptions } from './BrandList.action';
import { QueryDispatcher } from 'Util/Request';
import {showNotification} from 'Store/Notification/Notification.action';



export class BrandListDispatcher extends QueryDispatcher {
    __construct() {
        super.__construct('BrandList');
    }
    onSuccess({brandList : {items, brand_type_options} }, dispatch) {
        dispatch(updateBrandsList(items));
        dispatch(updateBrandsTypeOptions(brand_type_options));
    }

    clearBrandReduxState(dispatch){
        dispatch(updateBrandsList([]));
        dispatch(updateBrandsTypeOptions([]));
    }

    onError(error, dispatch) {
        dispatch(showNotification('error', 'Error fetching Config!', error));
    }

    prepareRequest(options) {
        return  BrandListQuery.getBrandListQuery(options);
    }
}
export default new BrandListDispatcher();

